import { gql, useMutation } from '@apollo/client';
import { useState } from 'react';
import { MutationGenerateSigninOtpArgs } from '@updater/consumer-graph/generated/graphql';

const GENERATE_SIGNIN_OTP = gql`
  mutation GenerateSigninOtp($input: GenerateSigninOtpInput!) {
    generateSigninOtp(input: $input)
  }
`;

export function useGenerateSigninOtp() {
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [resendLoading, setResendLoading] = useState(false);

  const [generateSigninOtp] = useMutation<
    { generateSigninOtp: boolean },
    MutationGenerateSigninOtpArgs
  >(GENERATE_SIGNIN_OTP);

  const generate = async (email: string): Promise<boolean> => {
    setError(null);
    setSuccessMessage(null);
    try {
      const result = await generateSigninOtp({
        variables: { input: { email } },
      });
      if (!result.data?.generateSigninOtp) {
        setError('Failed to send verification code. Please try again.');
        return false;
      }
      return true;
    } catch {
      setError('Failed to send verification code. Please try again.');
      return false;
    }
  };

  const resend = async (email: string): Promise<boolean> => {
    if (resendLoading) return false;
    setResendLoading(true);
    const success = await generate(email);
    if (success) setSuccessMessage('A new code has been sent to your email.');
    setResendLoading(false);
    return success;
  };

  const reset = () => {
    setError(null);
    setSuccessMessage(null);
  };

  return { generate, resend, reset, error, successMessage, resendLoading };
}
